import PropTypes from 'prop-types';

import { modifierList as cardModifiersList } from '../../components/3-molecules/card/props-list';
import { modifierList as setOfCardsModifiersList } from '../../components/4-organisms/set-of-cards/props-list';

export default {
  htmlProps: PropTypes.shape({
    heading: PropTypes.string,
    target: PropTypes.string,
    position: PropTypes.string,
    maxContents: PropTypes.number,
    maxOptions: PropTypes.number,
  }),
  widget: PropTypes.shape({
    name: PropTypes.string.isRequired,
    htmlId: PropTypes.string.isRequired,
    styles: PropTypes.shape({
      setsOfCardsModifiers: PropTypes.shape({
        rail: PropTypes.arrayOf(PropTypes.oneOf(setOfCardsModifiersList)),
        'in-grid-main': PropTypes.arrayOf(PropTypes.oneOf(setOfCardsModifiersList)),
      }).isRequired,
      cardModifiers: PropTypes.shape({
        rail: PropTypes.arrayOf(PropTypes.oneOf(cardModifiersList)),
        'in-grid-main': PropTypes.arrayOf(PropTypes.oneOf(cardModifiersList)),
      }).isRequired,
      skeletonColor: PropTypes.string.isRequired,
    }),
  }),
  $root: PropTypes.object.isRequired,
  state: PropTypes.object,
  actions: PropTypes.object, // set as required
};
